import type { Palette } from '@mui/material/styles';

import { colors } from './colors';

export const createLightPalette = () => {
  return {
    mode: 'light',
    primary: {
      main: `var(--sdk-primary, ${colors.blue[500]})`,
      contrastText: `var(--sdk-primary-contrast, ${colors.white})`,
      light: `var(--sdk-primary-light, ${colors.blue[200]})`,
      dark: `var(--sdk-primary-dark, ${colors.blue[600]})`,
    },
    secondary: {
      main: colors.blue[100],
      contrastText: colors.blue[800],
      light: colors.blue[50],
      dark: colors.blue[200],
    },
    tertiary: {
      main: colors.blue[100],
      contrastText: colors.blue[800],
    },
    text: {
      primary: colors.grey[900],
      secondary: colors.grey[500],
    },
    background: {
      default: `var(--sdk-light-bg, var(--body-background, ${colors.grey[50]}))`,
      defaultChannel: undefined,
    },
    divider: colors.grey[50],
    common: {
      white: colors.white,
      black: colors.black,
    },
    greys: {
      50: colors.grey[50],
      100: colors.grey[100],
      200: colors.grey[200],
      300: colors.grey[300],
      400: colors.grey[400],
      500: colors.grey[500],
      600: colors.grey[600],
      700: colors.grey[700],
      800: colors.grey[800],
      900: colors.grey[900],
    },
    blues: {
      50: colors.blue[50],
      100: colors.blue[100],
      200: colors.blue[200],
      300: colors.blue[300],
      400: colors.blue[400],
      500: colors.blue[500],
      600: colors.blue[600],
      700: colors.blue[700],
      800: colors.blue[800],
      900: colors.blue[900],
    },
    greens: {
      50: colors.green[50],
      100: colors.green[100],
      200: colors.green[200],
      300: colors.green[300],
      400: colors.green[400],
      500: colors.green[500],
      600: colors.green[600],
      700: colors.green[700],
      800: colors.green[800],
      900: colors.green[900],
    },
    oranges: {
      50: colors.orange[50],
      100: colors.orange[100],
      200: colors.orange[200],
      300: colors.orange[300],
      400: colors.orange[400],
      500: colors.orange[500],
      600: colors.orange[600],
      700: colors.orange[700],
      800: colors.orange[800],
      900: colors.orange[900],
    },
    reds: {
      50: colors.red[50],
      100: colors.red[100],
      200: colors.red[200],
      300: colors.red[300],
      400: colors.red[400],
      500: colors.red[500],
      600: colors.red[600],
      700: colors.red[700],
      800: colors.red[800],
      900: colors.red[900],
    },
    purple: colors.purple,
    violet: colors.violet,
  } as Palette;
};
